
import Loader from '@/components/ui/Loader';

const LoadingFeed = () => {
  return (
    <div className="animate-fade-in text-center py-8">
      <Loader size="large" />
      <p className="mt-4 text-gray-500 dark:text-gray-400">
        Chargement des vidéos en cours...
      </p>
    </div>
  );
};

export default LoadingFeed;
